import { createRouter, RouteRecordRaw, createWebHistory } from 'vue-router'
/* Layout */
import Layout from '@/layout/index.vue'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
    // {
    //     path: '/',
    //     component: Layout,
    //     redirect: '/home',
    //     children: [
    //         {
    //             path: 'home',
    //             component: () => import('@/views/home/index.vue'),
    //             name: 'home'
    //         }
    //     ]
    // },
    {
        path: '/',
        component: () => import('@/views/home/index.vue'),
        hidden: true
    },
    {
        path: '/login',
        component: () => import('@/views/login/index.vue'),
        hidden: true
    },
    {
        path: '/detail',
        component: () => import('@/views/collection/index.vue'),
        hidden: true
    },
    {
        path: '/confirm',
        component: () => import('@/views/confirm/index.vue'),
        hidden: true
    },
    {
        path: '/busconfirm',
        component: () => import('@/views/busconfirm/index.vue'),
        hidden: true
    },
    {
        path: '/service',
        component: () => import('@/views/subpage/service.vue'),
        hidden: true
    },
    {
        path: '/aboutUs',
        component: () => import('@/views/subpage/aboutUs.vue'),
        hidden: true,
    },
    {
        path: '/aboutUs0',
        component: () => import('@/views/subpage/aboutUs_copy.vue'),
        hidden: true,
    },
    {
        path: '/aboutUs1',
        component: () => import('@/views/subpage/aboutUs_2.vue'),
        hidden: true,
    },
    {
        path: '/aboutUs2',
        component: () => import('@/views/subpage/aboutUs_3.vue'),
        hidden: true,
    },
    {
        path: '/aboutUs3',
        component: () => import('@/views/subpage/aboutUs_4.vue'),
        hidden: true,
    },
    {
        path: '/aboutUs4',
        component: () => import('@/views/subpage/aboutUs_5.vue'),
        hidden: true,
    },
    {
        path: '/aboutUs5',
        component: () => import('@/views/subpage/aboutUs_6.vue'),
        hidden: true,
    },
    {
        path: '/aboutUs6',
        component: () => import('@/views/subpage/aboutUs_7.vue'),
        hidden: true,
    },
    {
        path: '/aboutUs7',
        component: () => import('@/views/subpage/aboutUs_8.vue'),
        hidden: true,
    },
    {
        path: '/aboutUs8',
        component: () => import('@/views/subpage/aboutUs_9.vue'),
        hidden: true,
    },
    // {
    //     path: '/aboutUs3',
    //     component: () => import('@/views/subpage/aboutUs.vue'),
    //     hidden: true,
    // },
    // {
    //     path: '/aboutUs4',
    //     component: () => import('@/views/subpage/aboutUs.vue'),
    //     hidden: true,
    // },
    // {
    //     path: '/aboutUs5',
    //     component: () => import('@/views/subpage/aboutUs.vue'),
    //     hidden: true,
    // },
    {
        path: '/help',
        component: () => import('@/views/subpage/help.vue'),
        hidden: true
    },
    {
        path: '/reserveOrder',
        component: () => import('@/views/subpage/reserveOrder.vue'),
        hidden: true
    },
    // {
    //     path: '/redirect',
    //     component: Layout,
    //     hidden: true,
    //     children: [
    //         {
    //             path: '/redirect/:path(.*)',
    //             component: () => import('@/views/redirect/index.vue')
    //         }
    //     ]
    // }
]

const routes: Array<RouteRecordRaw> = [...constantRoutes]
// console.log(import.meta.env.MODE, 'import.meta.env.MODE')
const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
